import { t } from "i18next";
import { PERMISSION_ACTIONS, PERMISSION_MODULES } from "../../constants/permissions";

type Lang = "ca" | "es" | "en";

export function getPermissionDescription(
    permission: string,
    lang: Lang
) {
    const [module, action] = permission.split(".");

    const actionText =
        PERMISSION_ACTIONS[action as keyof typeof PERMISSION_ACTIONS]?.[lang];

    const moduleText =
        PERMISSION_MODULES[module as keyof typeof PERMISSION_MODULES]?.[lang];

    if (!actionText || !moduleText) return permission;

    return `${actionText} � ${moduleText}`;
}

export function getPermissionDescriptionNarrative(
    section: string,
    action: string
) {
    const sectionTextRaw = t(`permission:sections.${section}`, section);
    const actionText = t(`permission:actions.${action}`, action);

    const sectionText =
        sectionTextRaw.charAt(0).toLowerCase() + sectionTextRaw.slice(1);

    return `${actionText} ${sectionText}`;
}
